module.exports = __webpack_public_path__ + "img/new_index_service_bg2.236fc835.png";